import { GetTodaysDateINdmy } from "../../../CommonFunction/GetTodaysDate";

export function autoSetReference({
  ReferenceData,
  setRefRows,
  lastModified,
  Formula,
  getTotalAmount,
  FormData,
  Party,
  initialRef,
  AmountDetails,
  TransactionTypeDetails,
  TransactionType,
}) {
  const isRelevantFieldModified =
    ["Tax_Group", "Item_Value", "Quantity", "Amount", "Stock_Item"].includes(lastModified?.fieldName) ||
    lastModified?.fieldName?.includes("Tax_Group");
  console.log(ReferenceData);
  const total = getTotalAmount(Formula);
  const refObject = ReferenceData ? ReferenceData[1] : {};
  const refKeys = refObject ? Object.keys(refObject) : [];
  const refExists = refKeys.length > 0;
  console.log(refKeys, ReferenceData, "aaaaaaaaa");
  // ✅ Exit early if more than one reference already exists
  if (refKeys.length > 1) return;

  if (
    total &&
    isRelevantFieldModified &&
    FormData?.Party &&
    (Party?.Balance_Method === "Bill By Bill" || Party?.Balance_Method === true)
  ) {
    if (!refExists) {
      // Create new reference using initialRef
      const InitialRef = [
        ...initialRef.slice(0, -1),
        AmountDetails,
        TransactionTypeDetails,
        initialRef[initialRef.length - 1],
      ];

      const singleRef = InitialRef.map((item) => {
        if (item.name === "Particular") return { ...item, value: FormData?.Ref_No || FormData?.Invoice_No || "" };
        if (item.name === "Type") return { ...item, value: `New Reference` };
        if (item.name === "Amount") return { ...item, value: total };
        if (item.name === "TransactionType") return { ...item, value: TransactionType };
        if (item.name === "RefDate") return { ...item, value: GetTodaysDateINdmy() };
        return item;
      });

      setRefRows({
        [1]: {
          [Math.random() * 10]: singleRef,
        },
      });
    } else {
      // Update existing reference only if exactly one exists
      const updated = Object.entries(refObject).reduce((acc, [key, valueArray]) => {
        const newValueArray = valueArray.map((field) => {
          if (field.name === "Amount") return { ...field, value: total };
          if (field.name === "Particular") return { ...field, value: FormData?.Ref_No || FormData?.Invoice_No || "" };
          if (field.name === "RefDate") return { ...field, value: GetTodaysDateINdmy() };
          return field;
        });

        acc[key] = newValueArray;
        return acc;
      }, {});

      setRefRows((prev) => ({
        ...prev,
        [1]: updated,
      }));
    }
  }
}
